/*        {
          "label": "Breakdowns",
          "units": "Codes",
          "value": [
            {
              "label": "Totals",
              "units": "Codes",
              "value": [
                {
                  "label": "Errors",
                  "units": "Codes",
                  "value": 0,
                  "filter": {
                    "predicate": "AND",
                    "fields": []
                  },
                  "order": 0
                },
                {
                  "label": "Total",
                  "units": "Codes",
                  "value": 1,
                  "filter": {
                    "predicate": "AND",
                    "fields": []
                  },
                  "order": 1
                },
                {
                  "label": "Percent",
                  "units": "Codes",
                  "value": 0.0,
                  "filter": {
                    "predicate": "AND",
                    "fields": []
                  },
                  "order": 2
                },
                {
                  "label": "Create",
                  "units": "Codes",
                  "value": 0,
                  "filter": {
                    "predicate": "AND",
                    "fields": []
                  },
                  "order": 3
                },
                {
                  "label": "Update",
                  "units": "Codes",
                  "value": 0,
                  "filter": {
                    "predicate": "AND",
                    "fields": []
                  },
                  "order": 4
                },
                {
                  "label": "Delete",
                  "units": "Codes",
                  "value": 0,
                  "filter": {
                    "predicate": "AND",
                    "fields": []
                  },
                  "order": 5
                }
              ],
              "filter": {
                "predicate": "AND",
                "fields": []
              },
              "order": 0
            },
            {
              "label": "EM Codes",
              "units": "Codes",
              "value": [
                {
                  "label": "Errors",
                  "units": "Codes",
                  "value": 0,
                  "filter": {
                    "predicate": "AND",
                    "fields": []
                  },
                  "order": 0
                },
                {
                  "label": "Total",
                  "units": "Codes",
                  "value": 1,
                  "filter": {
                    "predicate": "AND",
                    "fields": []
                  },
                  "order": 1
                },
                {
                  "label": "Percent",
                  "units": "Codes",
                  "value": 0.0,
                  "filter": {
                    "predicate": "AND",
                    "fields": []
                  },
                  "order": 2
                },
                {
                  "label": "Create",
                  "units": "Codes",
                  "value": 0,
                  "filter": {
                    "predicate": "AND",
                    "fields": []
                  },
                  "order": 3
                },
                {
                  "label": "Update",
                  "units": "Codes",
                  "value": 0,
                  "filter": {
                    "predicate": "AND",
                    "fields": []
                  },
                  "order": 4
                },
                {
                  "label": "Delete",
                  "units": "Codes",
                  "value": 0,
                  "filter": {
                    "predicate": "AND",
                    "fields": []
                  },
                  "order": 5
                }
              ],
              "filter": {
                "predicate": "AND",
                "fields": []
              },
              "order": 0
            }
          ],
          "filter": {
            "predicate": "AND",
            "fields": []
          },
          "order": 3
        }
          */
interface Filter {
  predicate: string
  fields: any[]
}

export interface BreakdownValue {
  label: string
  units: string
  value: number | number[] | BreakdownValue[] | string
  filter: Filter
  order: number
}

function isFraction(n: number): boolean {
  return n % 1 !== 0
}

export function formatBreakdownValue(b?: BreakdownValue): string {
  if (!b) {
    return '0'
  }
  if (typeof b.value === 'number') {
    if (b.label === 'Percent') {
      const p = b.value * 100
      const f = isFraction(p)
      return (f ? p.toFixed(1) : p) + '%'
    }
    return b.value.toString()
  }
  if (Array.isArray(b.value)) {
    return b.value.join(', ')
  }
  return b.value as string
}

export interface Breakdown {
  label: string
  units: string
  value: BreakdownValue[]
  filter: Filter
  order: number
}

const breakdowns: Breakdown = {
  label: 'Breakdowns',
  units: 'Codes',
  value: [
    {
      label: 'Totals',
      units: 'Codes',
      value: [
        {
          label: 'Errors',
          units: 'Codes',
          value: 0,
          filter: {
            predicate: 'AND',
            fields: [],
          },
          order: 0,
        },
        {
          label: 'Total',
          units: 'Codes',
          value: 1,
          filter: {
            predicate: 'AND',
            fields: [],
          },
          order: 1,
        },
        {
          label: 'Percent',
          units: 'Codes',
          value: 0.0,
          filter: {
            predicate: 'AND',
            fields: [],
          },
          order: 2,
        },
        {
          label: 'Create',
          units: 'Codes',
          value: 0,
          filter: {
            predicate: 'AND',
            fields: [],
          },
          order: 3,
        },
        {
          label: 'Update',
          units: 'Codes',
          value: 0,
          filter: {
            predicate: 'AND',
            fields: [],
          },
          order: 4,
        },
        {
          label: 'Delete',
          units: 'Codes',
          value: 0,
          filter: {
            predicate: 'AND',
            fields: [],
          },
          order: 5,
        },
      ],
      filter: {
        predicate: 'AND',
        fields: [],
      },
      order: 0,
    },
    {
      label: 'EM Codes',
      units: 'Codes',
      value: [
        {
          label: 'Errors',
          units: 'Codes',
          value: 0,
          filter: {
            predicate: 'AND',
            fields: [],
          },
          order: 0,
        },
        {
          label: 'Total',
          units: 'Codes',
          value: 1,
          filter: {
            predicate: 'AND',
            fields: [],
          },
          order: 1,
        },
        {
          label: 'Percent',
          units: 'Codes',
          value: 0.0,
          filter: {
            predicate: 'AND',
            fields: [],
          },
          order: 2,
        },
        {
          label: 'Create',
          units: 'Codes',
          value: 0,
          filter: {
            predicate: 'AND',
            fields: [],
          },
          order: 3,
        },
        {
          label: 'Update',
          units: 'Codes',
          value: 0,
          filter: {
            predicate: 'AND',
            fields: [],
          },
          order: 4,
        },
        {
          label: 'Delete',
          units: 'Codes',
          value: 0,
          filter: {
            predicate: 'AND',
            fields: [],
          },
          order: 5,
        },
      ],
      filter: {
        predicate: 'AND',
        fields: [],
      },
      order: 0,
    },
  ],
  filter: {
    predicate: 'AND',
    fields: [],
  },
  order: 3,
}

export function getBreakdown(values: BreakdownValue[]): Breakdown | undefined {
  const v = values.find((v) => v.label === 'Breakdowns')
  return v ? (v as Breakdown) : undefined
}
